export default __webpack_public_path__ + "static/media/sharples.511e03df.jpg";